module.exports = __webpack_public_path__ + "static/img/Aland.c9cf0523.png";